import * as React from 'react';

const validateChildTypes = (children, types, parent) => {
    if (!children) {
        return;
    }
    let hasValidChildren = true;
    const typeNames = types.map((type) => type.name);
    const expected = (invalid) => `Invalid child type: <${invalid} />\nExpected children of <${parent} />: ${typeNames.join(', ')};`;
    const validate = (child) => {
        if (!child || !child.type) {
            hasValidChildren = false;
            return;
        }
        if (!typeNames.includes(child.type.name)) {
            hasValidChildren = false;
            console.error(expected(child.type.name));
        }
    };
    React.Children.forEach(children, (child) => {
        validate(child);
    });
    return hasValidChildren;
};
const validateChildTypeNames = (children, validTypeNames, parent) => {
    // If no children or production environment, skip validation.
    if (!children || process.env.NODE_ENV === 'production') {
        return;
    }
    let hasValidChildren = true;
    const expected = (invalid) => `Invalid child type: <${invalid} />\nExpected children of <${parent} />: ${validTypeNames.join(', ')};`;
    const validate = (child) => {
        if (!child || !child.type) {
            hasValidChildren = false;
            return;
        }
        if (!validTypeNames.includes(child.type.name)) {
            hasValidChildren = false;
            console.error(expected(child.type.name));
        }
    };
    React.Children.forEach(children, (child) => {
        validate(child);
    });
    return hasValidChildren;
};

export { validateChildTypeNames as a, validateChildTypes as v };
//# sourceMappingURL=index-chunk.esm.js.map
